import React, { useState } from "react";
import Topbar from "../../components/topbar/Topbar";
import styles from "./eventFeeds.module.css";

// importing create event modal
import CreateEventModal from "../../components/createEventModal/CreateEventModal";

import Carousel from "react-material-ui-carousel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// Redux stuff
import { connect } from "react-redux";

function EventFeeds() {
    const [state, setState] = useState({
        images: [
            {
                src: "https://img.freepik.com/free-vector/elegant-event-party-banner-with-black-splash_1361-2171.jpg?size=626&ext=jpg",
            },
            {
                src: "https://img.freepik.com/free-vector/technology-conference-poster-template_1361-1211.jpg?size=626&ext=jpg",
            },
            {
                src: "https://img.freepik.com/free-vector/abstract-technology-conference-template_1361-1213.jpg?size=626&ext=jpg",
            },
        ],
    });

    const [openCreateEvent, setOpenCreateEvent] = React.useState(false);

    const openEventCreatorModal = () => {
        setOpenCreateEvent(true);
    };

    const closeEventCreatorModal = () => {
        setOpenCreateEvent(false);
    };

    return (
        <div>
            <Topbar
                name={"Events"}
                buttonText={"Create New"}
                openEventCreatorModal={openEventCreatorModal}
            />
            <CreateEventModal
                openCreateEvent={openCreateEvent}
                closeEventCreatorModal={closeEventCreatorModal}
            />
            <div className={styles.container}>
                <section className={styles.eventsContainer}>
                    <div className={styles.eventCard}>
                        <header className={styles.eventCardHeader}>
                            <div className={styles.eventCardHeaderLeft}>
                                <h1>Event Name</h1>
                                <span>Upcoming Event</span>
                            </div>
                            <div className={styles.eventCardHeaderRight}>
                                <span>TechSoc</span>
                                <img
                                    src="https://img.freepik.com/free-vector/technology-conference-poster-template_1361-1211.jpg?size=626&ext=jpg"
                                    alt=""
                                />
                            </div>
                        </header>
                        <Carousel
                            NextIcon={
                                <ArrowForwardIosIcon
                                    style={{ width: "10px", height: "10px" }}
                                />
                            }
                            PrevIcon={
                                <ArrowBackIosIcon
                                    style={{ width: "10px", height: "10px" }}
                                />
                            }
                            animation="slide"
                            swipe={true}
                            indicators={false}
                            navButtonsAlwaysVisible={false}
                        >
                            {state.images.map((item, i) => (
                                <Item key={i} item={item} />
                            ))}
                        </Carousel>
                        <section className={styles.applicationButtons}>
                            <h2>Application</h2>
                            <button>Easy Apply</button>
                        </section>
                        <Accordion className={styles.eventDescriptionContainer}>
                            <AccordionSummary
                                className={
                                    styles.eventDescriptionHeadingContainer
                                }
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <h1 className={styles.eventDescriptionHeading}>
                                    Event Description
                                </h1>
                            </AccordionSummary>
                            <AccordionDetails
                                className={
                                    styles.eventDescriptionHeadingContainer
                                }
                            >
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Tellus in hac habitasse platea dictumst
                                    vestibulum. Varius quam quisque id diam vel
                                    quam elementum pulvinar etiam. Tincidunt
                                    ornare massa eget egestas purus viverra a.
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Tellus in hac habitasse platea dictumst
                                    vestibulum. Varius quam quisque id diam vel
                                    quam elementum pulvinar etiam. Tincidunt
                                    ornare massa eget egestas purus viverra a
                                </p>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </section>
                <section className={styles.eventRegistrations}>
                    <h2>Details of the events you registered for</h2>
                </section>
            </div>
        </div>
    );
}

function Item(props) {
    return (
        <img
            style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
            }}
            src={props.item.src}
            alt=""
        />
    );
}

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, {})(EventFeeds);
